import { FormInstance } from 'antd/lib/form';
import { ReactElement, useEffect } from 'react';
import CcxComponentProps from '../../../core/CcxComponent';
import CloudProvider from '../../../types/CloudProvider';
import DeploymentOptions from '../../../types/DeploymentOptions';
import InstanceVolumeIopsValue from '../../../types/InstanceVolumeIopsValue';
import InstanceVolumeSize from '../../../types/InstanceVolumeSize';
import InstanceVolumeType from '../../../types/InstanceVolumeType';
import User from '../../../types/User';
import InstanceSizeForm from './InstanceSizeForm';
import DatabaseVendor from '../../../types/DatabaseVendor';
import styles from './WizardFormConfigurationStep3.module.less';
import InstanceSize from '../../../types/InstanceSize';
interface Props extends CcxComponentProps {
    selectedTech?: DatabaseVendor;
    handleInstanceSizeChange: Function;
    deploymentOptions?: DeploymentOptions;
    cloudProvider: CloudProvider | undefined;
    user?: User;
    handleVolumeTypeChange: Function;
    volumeSize?: InstanceVolumeSize;
    volumeType?: InstanceVolumeType;
    volumeIops?: InstanceVolumeIopsValue;
    enteredVolumeSize?: number;
    setEnteredVolumeSize: Function;
    setEnteredIOPS: Function;
    instance: InstanceSize | undefined;
    form: FormInstance;
    StepsExtra: Function;
    handleVolumeIopsChange: (
        value: InstanceVolumeIopsValue | undefined
    ) => void;
    isBackupRestore: boolean;
    setVolumeSize: React.Dispatch<
        React.SetStateAction<InstanceVolumeSize | undefined>
    >;
}

export function WizardFormConfigurationStep3({
    testId = 'WizardFormConfigurationStep3',
    selectedTech,
    handleInstanceSizeChange,
    deploymentOptions,
    cloudProvider,
    instance,
    user,
    handleVolumeTypeChange,
    volumeSize,
    volumeType,
    volumeIops,
    setVolumeSize,
    enteredVolumeSize,
    setEnteredVolumeSize,
    setEnteredIOPS,
    form,
    StepsExtra,
    handleVolumeIopsChange,
    isBackupRestore,
}: Props): ReactElement {
    useEffect(() => {
        if (!volumeType?.hasIops && !isBackupRestore) {
            form.setFieldsValue({
                volumeIops: undefined,
            });
        }
    }, [volumeType]);

    useEffect(() => {
        if (volumeSize) {
            setEnteredVolumeSize && setEnteredVolumeSize(volumeSize?.default);
        }
    }, [volumeSize]);

    useEffect(() => {
        if (volumeType?.hasIops && volumeIops) {
            setEnteredIOPS && setEnteredIOPS(volumeIops?.default);
        } else {
            setEnteredIOPS && setEnteredIOPS(undefined);
        }
    }, [volumeIops]);

    useEffect(() => {
        if (cloudProvider && deploymentOptions) {
            const instanceSizes =
                deploymentOptions?.getInstanceSizes(cloudProvider);

            if (instanceSizes?.length === 1) {
                form.setFieldsValue({
                    instanceSize: instanceSizes[0],
                });
                handleInstanceSizeChange({
                    target: { value: instanceSizes[0] },
                });
            }

            const volumeTypes =
                deploymentOptions?.getVolumeTypes(cloudProvider);

            if (volumeTypes?.length === 1) {
                form.setFieldsValue({
                    volumeType: volumeTypes[0].code,
                });
                handleVolumeTypeChange({
                    target: { value: volumeTypes[0].code },
                });
            }
        }
    }, [cloudProvider, deploymentOptions]);

    return (
        <div data-testid={testId}>
            <InstanceSizeForm
                testId={testId}
                selectedTech={selectedTech}
                handleInstanceSizeChange={handleInstanceSizeChange}
                deploymentOptions={deploymentOptions}
                cloudProvider={cloudProvider}
                form={form}
                handleVolumeTypeChange={handleVolumeTypeChange}
                volumeSize={volumeSize}
                volumeType={volumeType}
                volumeIops={volumeIops}
                setVolumeSize={setVolumeSize}
                enteredVolumeSize={enteredVolumeSize}
                setEnteredVolumeSize={setEnteredVolumeSize}
                setEnteredIOPS={setEnteredIOPS}
                instance={instance}
                handleVolumeIopsChange={handleVolumeIopsChange}
            />
            <div className={styles.StepsExtraSmallScreen}>
                <StepsExtra />
            </div>
        </div>
    );
}
